/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CommentReactionSummary model module.
 * @module model/CommentReactionSummary
 * @version V1
 */
class CommentReactionSummary {
    /**
     * Constructs a new <code>CommentReactionSummary</code>.
     * @alias module:model/CommentReactionSummary
     */
    constructor() { 
        
        CommentReactionSummary.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CommentReactionSummary</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CommentReactionSummary} obj Optional instance to populate.
     * @return {module:model/CommentReactionSummary} The populated <code>CommentReactionSummary</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CommentReactionSummary();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('reaction')) {
                obj['reaction'] = ApiClient.convertToType(data['reaction'], 'String');
            }
            if (data.hasOwnProperty('reactedBy')) {
                obj['reactedBy'] = ApiClient.convertToType(data['reactedBy'], 'Number');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CommentReactionSummary</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CommentReactionSummary</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['reaction'] && !(typeof data['reaction'] === 'string' || data['reaction'] instanceof String)) {
            throw new Error("Expected the field `reaction` to be a primitive type in the JSON string but got " + data['reaction']);
        }

        return true;
    }


}



/**
 * @member {Number} id
 */
CommentReactionSummary.prototype['id'] = undefined;

/**
 * @member {String} reaction
 */
CommentReactionSummary.prototype['reaction'] = undefined;

/**
 * @member {Number} reactedBy
 */
CommentReactionSummary.prototype['reactedBy'] = undefined;

/**
 * @member {Date} createdAt
 */
CommentReactionSummary.prototype['createdAt'] = undefined;






export default CommentReactionSummary;

